<template>
  <modal :show.sync="localShow" :persistent="true" :modalContentClasses="{ 'p-0': true }">
    <div class="px-4 pt-4 pb-3">
      <div class="d-flex align-items-center mb-3">
        <div class="notice-icon d-flex align-items-center justify-content-center mr-3">
          <i class="fa fa-info"></i>
        </div>
        <h5 class="m-0 text-custom-text font-weight-600">提醒事項</h5>
      </div>
      <p class="font-size-15 mb-0 notice-text text-custom-text">{{ message }}</p>
    </div>

    <template slot="footer">
      <div class="w-100 text-center">
        <base-button type="main-color" class="px-5" @click="onConfirm">確認</base-button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import BaseButton from "@/components/BaseButton.vue";

export default {
  name: "LoginNoticeDialog",
  components: {Modal, BaseButton},
  props: {
    show: {type: Boolean, default: false},
    message: {type: String, default: ''},
  },
  computed: {
    localShow: {
      // Modal 本身只能靠外部改 show 來關（persistent 擋掉了背景點擊與 ESC），
      // 所以這裡不把 update:show 往外轉發，避免有其他地方誤把它關掉。
      get() {
        return this.show;
      },
      set() {
      },
    },
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style scoped>
.notice-icon {
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  background-color: rgba(243, 152, 0, 0.12);
  color: #F39800;
  font-size: 15px;
}

.notice-text {
  white-space: pre-line;
  line-height: 1.9;
}
</style>
